import React from 'react';
import { RestAPI } from '@/util/net';
import { MainComponentBox } from '@/util/util.jsx';
import { Button } from 'react-bootstrap';
export default class Reindex extends React.PureComponent {
  constructor(props) {
    super(props);
    this.reindex = this.reindex.bind(this);
    this.state = {};
  }
  reindex() {
    this.setState({ complete: undefined, inProcess: true });
    RestAPI.get('/search/api/reindex').then(() => {
      this.setState({ complete: true, inProcess: false });
    }).catch(() => {
      this.setState({ complete: false, inProcess: false });
    });
  }
  render() {
    return (
      <MainComponentBox>
        <div>This action to be preformed only after SQL databse is migrated.</div>
        <h4>Attention!
         Any actions towards DB performed by users during reindexation may be not indexed.
        </h4>
        <Button bsStyle="danger" onClick={this.reindex} disabled={this.state.inProcess}>
          {this.state.inProcess ? 'Working...' : 'Reindex'}
        </Button>
        <div>
          {this.state.complete && 'Done'}
          {this.state.complete === false && 'Failed'}
        </div>
      </MainComponentBox>
    );
  }
}
